export default {
  "decreaseValue": "Decrease value",
  "increaseValue": "Increase value",
  "ok": "OK",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "close": "Close",
  "closeDialog": "Close dialog",
  "dismissNotification": "Dismiss notification",
  "retry": "Retry",
  "loading": "Loading...",
  "search": "Search...",
  "noResults": "No results",
  "noResultsFound": "No results found.",
  "noFilterResults": "No results match your filters.",
  "clearFilters": "Clear filters",
  "actions": "Actions",
  "filters": "Filters",
  "searchTable": "Search table",
  "selectAll": "Select all on page",
  "selectRow": "Select row",
  "all": "All",
  "allLabel": "All {{label}}",
  "filterLabel": "{{label}} filter",
  "filterPlaceholder": "Filter {{label}}",
  "searchLabel": "Search {{label}}",
  "noItems": "No items",
  "itemRange_one": "Showing {{start}} - {{end}} of {{total}} item",
  "itemRange_many": "Showing {{start}} - {{end}} of {{total}} items",
  "itemRange_other": "Showing {{start}} - {{end}} of {{total}} items",
  "perPage": "Per page:",
  "itemsPerPage": "Items per page",
  "firstPage": "First page",
  "previousPage": "Previous page",
  "nextPage": "Next page",
  "lastPage": "Last page",
  "pageIndicator": "Page {{page}} / {{pages}}",
  "rows": "Rows",
  "rowsPerPage": "Rows per page",
  "previous": "Previous",
  "next": "Next",
  "tablePage": "Page {{page}} of {{pages}}",
  "onThisPage": "On this page",
  "sections": "Sections",
  "openTableOfContents": "Open table of contents",
  "closeTableOfContents": "Close table of contents",
  "calloutNote": "Note",
  "calloutTip": "Tip",
  "calloutImportant": "Important",
  "calloutWarning": "Warning",
  "calloutCaution": "Caution",
  "timeRange": "Time range",
  "loadingDashboard": "Loading dashboard…",
  "updateAvailable": "Update available",
  "statusDegraded": "Status degraded",
  "upToDate": "Up to date",
  "badgeDashboardCurrent": "dashboard up-to-date",
  "badgeUpdateAvailable": "update available",
  "notConfigured": "not configured",
  "unavailable": "unavailable",
  "systemStatusDetails": "System status — click for details",
  "systemStatus": "System status",
  "updatedAt": "Updated {{value}}",
  "installedVersion": "Installed",
  "latestVersion": "Latest",
  "currentVersion": "Current",
  "currentVersionLabel": "Current:",
  "latestVersionLabel": "Latest:",
  "updateQuickBox": "Update QuickBox",
  "dashboard": "Dashboard",
  "updateDashboard": "Update dashboard",
  "changelog": "Changelog",
  "systemDashboard": "System Dashboard",
  "viewSystemLogs": "View system logs",
  "stopped": "Stopped",
  "degraded": "Degraded",
  "updatePending": "Update pending",
  "running": "Running",
  "unknown": "Unknown",
  "appStatusDetails": "{{app}} status — click for details",
  "appStatus": "App status",
  "namedAppStatus": "{{app}} status",
  "packagePending": "A new version has been detected but the download package has not been published upstream yet. The update will become available once the package is released.",
  "updateToVersion": "Update to {{version}}",
  "updateToLatest": "Update to latest",
  "manage": "Manage",
  "dismissAlert": "Dismiss alert",
  "noOptions": "No options",
  "selectTags": "Select tags...",
  "removeTag": "Remove {{tag}}",
  "tagPicker": "Tag picker",
  "searchOrCreate": "Search or create...",
  "searchTags": "Search tags",
  "clearSearch": "Clear search",
  "noMatchingTags": "No matching tags",
  "noTags": "No tags available",
  "createTag": "Create “{{tag}}”",
  "keyboardNavigate": "navigate",
  "keyboardSelect": "select",
  "keyboardClose": "close",
  "selectColor": "Select a color",
  "colorPresets": "Presets",
  "namedColor": "Select color {{color}}",
  "customHex": "Custom Hex",
  "customHexColor": "Custom hex color",
  "apply": "Apply",
  "applyCustomColor": "Apply custom color",
  "clearColor": "Clear color",
  "value": "Value",
  "hide": "Hide",
  "reveal": "Reveal",
  "hideValue": "Hide value",
  "revealValue": "Reveal value",
  "copied": "Copied!",
  "copy": "Copy",
  "copyToClipboard": "Copy to clipboard",
  "adminViewing": "Admin Viewing",
  "adminOnly": "Only visible to admins",
  "buttonVisibility": "Manage who can see this button:",
  "userAdmin": "User Admin",
  "toggleScopeEditing": "Toggle {{scope}} editing globally for all users",
  "appTemplates": "App Templates",
  "visibilityOverrides": "Configure per-app visibility overrides",
  "unsupportedFile": "Unsupported file",
  "logoImageRequired": "Brand logos must be an image.",
  "logoUploaded": "Logo uploaded",
  "uploadFailed": "Upload failed",
  "uploading": "Uploading...",
  "replaceLogo": "Replace logo",
  "uploadLogo": "Upload logo",
  "dropToUpload": "Drop to upload",
  "dragCropHint": "or drag and drop · crop and resize before saving",
  "reset": "Reset",
  "mapCredits": "Map credits",
  "statusUnavailable": "Status unavailable",
  "serviceStoppedUpdate": "Service stopped — update available: {{version}}",
  "serviceStopped": "Service stopped",
  "versionAvailable": "Update available: {{version}}",
  "feedbackInvalidCsrf": "Invalid CSRF token",
  "feedbackApiKeyReadOnly": "The Read Key cannot perform this action",
  "feedbackUnauthorized": "Unauthorized",
  "feedbackMaintenance": "System is in maintenance mode.",
  "feedbackServerError": "Server error",
  "feedbackBadRequest": "Bad request"
} as const;
